import { isFlow } from '../utils/isFlow';
import { Flow } from 'signup-constants/Flow';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { H1 } from 'foundations-components/transitional/components/H1';
import { Step } from 'signup-constants/Step';
import { getRedirectUrl } from '../store/app/selectors';
import { useSelector } from 'react-redux';
import { BaseView } from '../views/BaseView';
import { jsx as _jsx } from "react/jsx-runtime";
const EmbeddedSignupContinueScreen = () => {
  const stepKey = Step.EmbeddedSignupContinueScreen;
  const buttonMessage = isFlow(Flow.Academy) ? 'embeddedSignup.continueToHubSpotAcademy' : 'embeddedSignup.continueToPortal';
  const redirectUrl = useSelector(getRedirectUrl);
  const redirectToPage = () => {
    window.open(redirectUrl, '_top');
  };
  return /*#__PURE__*/_jsx(BaseView, {
    stepKey: stepKey,
    children: /*#__PURE__*/_jsx(ResultsMessage, {
      illustration: "success-green",
      illustrationProps: {
        alt: 'Green tick'
      },
      title: /*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "embeddedSignup.accountCreated"
        })
      }),
      children: /*#__PURE__*/_jsx(Button, {
        margin: "auto",
        marginBlockEnd: "500",
        marginBlockStart: "500",
        responsive: false,
        use: "primary",
        onClick: () => redirectToPage(),
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: buttonMessage
        })
      })
    })
  });
};
export default EmbeddedSignupContinueScreen;